import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/insights/mutationTypes';

export default {
  [types.SET_INSIGHTS]: createSetPropMutation('insights', []),
  [types.CLEAR_INSIGHTS]: createClearPropMutation('insights', []),
  [types.SET_INSIGHTS_LOADING]: createSetPropMutation('insightsLoading', false),
  [types.SET_ASSET_CORRELATION]: createSetPropMutation('assetCorrelation', {}),
  [types.CLEAR_ASSET_CORRELATION]: createClearPropMutation('assetCorrelation', {}),
};
